import { ATTRIBUTE_VIEW_OPTIONS } from '../constants/attributes';

export const hasQuantitativeAttributeScores = attributes =>
  attributes.some(attribute => attribute?.scoreByOthers !== null);

export const prepareTimelineTableColumns = labels => [
  { label: labels.sentAt },
  { label: labels.survey },
  { label: labels.status },
];

export const prepareFeedbackTableColumns = labels => [
  { label: labels.sentAt },
  { label: labels.comment },
  { label: labels.reviewer },
];

export const prepareAnswerWeight = answerWeight => parseFloat(answerWeight);

export const prepareActiveAttributes = attributes => {
  return attributes.filter(attribute => attribute.is_active);
};

export const prepareAttributesViewOptions = labels =>
  ATTRIBUTE_VIEW_OPTIONS.map(view => ({
    ...view,
    name: labels[view.key],
  }));
